"use client";

import { ArrowUp, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-5 w-20 bg-muted-dark/30 animate-pulse rounded" />)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-col sm:flex-row gap-3 sm:gap-6">
        {menuItems.slice(0, 4).map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-[var(--duration-fast)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return <footer ref={ref} className={`bg-dark-background text-foreground-dark py-12 transition-opacity duration-[var(--duration-slow)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex flex-col items-center gap-8">
          {}
          <div className="flex flex-col items-center gap-3">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/smart_buy_appliances_logo.png" alt="Smart Buy Appliances - Raleigh Durham NC" className="h-7" />
            <div className="flex items-center gap-2 text-sm text-foreground-dark/70 bg-primary/10 px-4 py-2 rounded-full">
              <MapPin className="size-4" />
              <span>Proudly Serving Raleigh-Durham Area</span>
            </div>
          </div>

          {}
          <nav className="flex justify-center">
            <MenuProvider menu_id="25">
              <FooterMenuConsumer />
            </MenuProvider>
          </nav>

          {}
          <div className="flex flex-col items-center gap-4 w-full max-w-2xl">
            <h3 className="font-display text-lg font-semibold text-foreground-dark text-center">
              Visit Our Raleigh Store or Call Today
            </h3>
            <div className="flex flex-wrap justify-center items-center gap-6">
              <Link to="tel:(919) 703-0041" className="flex items-center gap-2 text-foreground-dark/80 hover:text-accent hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)]">
                <Phone className="size-5" />
                <span className="text-sm font-medium">(919) 703-0041</span>
              </Link>

              <Link to="https://maps.google.com/?q=4100+Atlantic+Ave.+Raleigh+NC+27604" newTab className="flex items-center gap-2 text-foreground-dark/80 hover:text-accent hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)]">
                <MapPin className="size-5" />
                <span className="text-sm font-medium">4100 Atlantic Ave. Raleigh NC 27604</span>
              </Link>

              <Link to="mailto:" className="flex items-center gap-2 text-foreground-dark/80 hover:text-accent hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)]">
                <Mail className="size-5" />
                <span className="text-sm">Email Us</span>
              </Link>
            </div>
            <p className="text-center text-foreground-dark/60 text-sm mt-2">
              Convenient location in Raleigh, NC - Easy access from Durham, Cary, and all Triangle communities
            </p>
          </div>

          {}
          <Button onClick={scrollToTop} variant="ghost" size="icon" className="bg-primary/20 hover:bg-primary hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] rounded-full" aria-label="Back to Top">
            <ArrowUp className="size-5" />
          </Button>

          {}
          <div className="text-center text-foreground-dark/60 text-sm border-t border-foreground-dark/10 pt-6 w-full">
            <p>© {new Date().getFullYear()} Smart Buy Appliances - Raleigh, NC. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>;
}